
export default {
  props: {
    image: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isLoading: true
    }
  },
  methods: {
    onItemLoad () {
      this.isLoading = false
    }
  }
}
